module.exports = __webpack_public_path__ + "img/wizard.63dd3e4e.png";